import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Menu, Checkbox } from '@pocketlaw/tetris';
import { useFuse } from 'shared/domains/common-utils/useFuse';
import { ListItemText } from './styled';
export function UserList(props) {
    const { selected, users, onSelect } = props;
    const [searchInput, setSearchInput] = useState('');
    const { search, result } = useFuse(users, { keys: ['name'] });
    const selectable = searchInput ? result : users;
    const unSelected = selectable.filter((user) => !selected.find(({ id }) => id === user.id));
    const showSelected = selected.length > 0;
    const showunSelected = unSelected.length > 0;
    const handleChange = (value) => {
        setSearchInput(value);
        search(value);
    };
    return (<Fragment>
      <Menu.HeaderSearch value={searchInput} onChange={handleChange} placeholder={t({
            message: 'Search',
            comment: 'tasks filter - user list search placeholder',
        })}/>

      {showSelected && (<Fragment>
          <Menu.Label>
            <Trans comment="tasks filter - user list selected users title">Selected users</Trans>
          </Menu.Label>

          {selected.map((user) => (<Menu.Item key={user.id} onClick={() => onSelect(user, true)}>
              <ListItemText>{user.name || ''}</ListItemText>
              <Checkbox checked onChange={() => onSelect(user, true)}/>
            </Menu.Item>))}
        </Fragment>)}

      {showunSelected && (<Fragment>
          <Menu.Label>
            <Trans comment="tasks filter - user list unselected users title">All users</Trans>
          </Menu.Label>
          {unSelected.map((user) => (<Menu.Item key={user.id} onClick={() => onSelect(user, false)}>
              <ListItemText>{user.name || ''}</ListItemText>
              <Checkbox onChange={() => onSelect(user, false)}/>
            </Menu.Item>))}
        </Fragment>)}
    </Fragment>);
}
